import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { RequestInterceptor } from '@/Http/Axios/RequestInterceptor';
import { ResponseInterceptor } from '@/Http/Axios/ResponseInterceptor';
import qs from 'qs';
import { Http } from '@/Http/Http';

export class AxiosHttp<TResult> implements Http<TResult> {
    private axios: AxiosInstance;

    constructor(
        config?: AxiosRequestConfig,
        requestInterceptors?: RequestInterceptor[],
        responseInterceptors?: ResponseInterceptor[]
    ) {
        this.axios = axios.create(config);
        if (requestInterceptors !== undefined) {
            for (const interceptor of requestInterceptors) {
                this.axios.interceptors.request.use(interceptor.onFulfilled, interceptor.onRejected);
            }
        }
        if (responseInterceptors !== undefined) {
            for (const interceptor of responseInterceptors) {
                this.axios.interceptors.response.use(interceptor.onFulfilled, interceptor.onRejected);
            }
        }
    }

    get(url: string, query?: { [index: string]: unknown }): Promise<TResult> {
        const requestConfig: AxiosRequestConfig = {
            url: url,
            params: query,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        };
        return this.sendRequest(requestConfig);
    }

    post(url: string, body?: unknown, query?: { [index: string]: unknown }): Promise<TResult> {
        const requestConfig: AxiosRequestConfig = {
            headers: { 'Content-Type': 'application/json' },
            method: 'post',
            url: url,
            data: body,
            params: query,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        };
        return this.sendRequest(requestConfig);
    }

    private sendRequest<TResult>(config: AxiosRequestConfig): Promise<TResult> {
        return new Promise((resolve, reject) => {
            this.axios(config)
                .then((res) => {
                    resolve(res.data as TResult);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
